import React from "react";
import Home from "../components/Home";
import Header from "../components/Header";

function HomeScreen() {
  return (
    <>
      <Header />
      <Home />
    </>
  );
}

export default HomeScreen;
